import { setValue } from '../../lib/immutable_wrapper'
import {
    SYNCHRO_ADD_PARAMETERS,
    SYNCHRO_GET_ACTIVE_DAY,
    SYNCHRO_GET_PARAMETERS,
    SYNCHRO_GET_ACTIVE_USER,
    SYNCHRO_GET_API_ACTIVITY_TYPES,
} from './synchroConstants';

const initialState = {
    type:"NONE",
    sync_in_progress: false,
}

export function synchro(state = initialState, action) {

    switch (action.type) {
        case SYNCHRO_GET_ACTIVE_USER:
            if (!state.sync_in_progress) {
                state.sync_in_progress = true;
                return setValue(state, ['user'], action.payload);
            }

            return state;
        case SYNCHRO_GET_PARAMETERS:
            return setValue(state, ['parameters'], action.payload);
        case SYNCHRO_ADD_PARAMETERS:
            return state;
        case SYNCHRO_GET_ACTIVE_DAY:
            return setValue(state, ['sync_in_progress'], false);
        case SYNCHRO_GET_API_ACTIVITY_TYPES:
            return setValue(state, ['activityTypes'], action.payload);
        default:
            return state;
    }
}
